import { getAlbaranById, getAlbaranByIdSimple } from "api/Albaran.service"
import { getContactosByNifAndEmpresaId } from "api/Contacto.service"
import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { getPedidoById, getPedidoByIdSimple } from "api/Pedido.service"
import {
  getPresupuestoById,
  getPresupuestoByIdSimple,
} from "api/Presupuesto.service"
import {
  TIPO_DOCUMENTO_ENUM,
  TipoDocumentoEnumType,
} from "api/Types/TipoDocumentoEnum"
import { CREAR_ALBARAN, CREAR_FACTURA, CREAR_PEDIDO } from "routes/RoutePaths"
import { EmpresaActivaDocProps } from "../../FormCreacionDocumento"
import { MODES_DOCUMENTOS, TYPES_DOCUMENTOS } from "../../constant"

export interface FormasPago {
  description: string
  id: number | null
}

interface ConvertirDocumentoRedirectParams {
  initialType: TipoDocumentoEnumType | number
  finalType: string
  documentoId: string
  fieldValue: EmpresaActivaDocProps
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  push: (path: string, state: $TSMigrationFixMe) => void
  formasPago: FormasPago[]
  tiposImpuestosGenerales: ImpuestoEmpresaReadingDtoProps[]
}

const convertirDocumentoRedirect = async ({
  initialType,
  finalType,
  documentoId,
  fieldValue,
  push,
  formasPago,
  tiposImpuestosGenerales,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
ConvertirDocumentoRedirectParams): Promise<any> => {
  if (!documentoId) {
    return null
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let datosDocumento: $TSMigrationFixMe
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let datosDocumentoSimple: $TSMigrationFixMe
    // let ficherosDocumentos: $TSFixMe

    switch (initialType) {
      case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
        datosDocumento = await getPresupuestoById(documentoId)
        datosDocumentoSimple = await getPresupuestoByIdSimple(documentoId)
        break
      case TIPO_DOCUMENTO_ENUM.PEDIDO:
        datosDocumento = await getPedidoById(documentoId)
        datosDocumentoSimple = await getPedidoByIdSimple(documentoId)
        break
      case TIPO_DOCUMENTO_ENUM.ALBARAN:
        datosDocumento = await getAlbaranById(documentoId)
        datosDocumentoSimple = await getAlbaranByIdSimple(documentoId)
        break
      default:
        throw new Error(`Tipo de documento no válido: ${initialType}`)
    }

    if (datosDocumento.libradorId === fieldValue.id) {
      datosDocumento.librador = fieldValue
      const librado = await getContactosByNifAndEmpresaId(
        datosDocumento?.cliente?.cif,
        fieldValue.id as string
      )
      datosDocumento.librado = librado
      datosDocumento.mode = MODES_DOCUMENTOS.VENTA
    }
    if (datosDocumento.libradoId === fieldValue.id) {
      datosDocumento.librado = fieldValue
      const librador = await getContactosByNifAndEmpresaId(
        datosDocumento.usuario.cif,
        fieldValue.id
      )
      datosDocumento.librador = librador
      datosDocumento.mode = MODES_DOCUMENTOS.COMPRA
    }

    const getRoute = () => {
      switch (finalType) {
        case TYPES_DOCUMENTOS.PEDIDO:
          return CREAR_PEDIDO

        case TYPES_DOCUMENTOS.ALBARAN:
          return CREAR_ALBARAN

        case TYPES_DOCUMENTOS.FACTURA:
          return CREAR_FACTURA

        default:
          throw new Error(`Tipo de documento no válido: ${initialType}`)
      }
    }

    const formatDocAsociados = (docSerie: string) => {
      const tipoDoc =
        initialType === 25
          ? "Presupuesto"
          : initialType === 24
          ? "Pedido"
          : "Albaran"

      return `${tipoDoc}: ${docSerie}`
    }

    push(getRoute(), {
      ...datosDocumento,
      ...datosDocumentoSimple,
      docAsociado: datosDocumentoSimple.serieNumero
        ? formatDocAsociados(datosDocumentoSimple.serieNumero)
        : null,
      config: {
        screen: 3,
        formasPago,
        tiposImpuestosRepercutidos: tiposImpuestosGenerales.filter(
          (tax: ImpuestoEmpresaReadingDtoProps) =>
            tax.tipo ===
              (datosDocumento.libradorId === fieldValue.id ? 1 : 0) &&
            tax?.grupoImpuesto?.tipoGrupoImpuesto === 0
        ),
        tiposImpuestosRetenidos: tiposImpuestosGenerales.filter(
          (tax: ImpuestoEmpresaReadingDtoProps) =>
            tax.tipo ===
              (datosDocumento.libradorId === fieldValue.id ? 1 : 0) &&
            tax?.grupoImpuesto?.tipoGrupoImpuesto === 1
        ),
        // preferenceContat: dataContactPreferences,
      },
    })
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error al obtener los datos del documento:", error)
    return null
  }
}

export default convertirDocumentoRedirect
